export interface Testimonial {
  /** Attribution line exactly as written in the sales letter */
  attribution: string
  name: string
  age: number
  role: string
  location: string
  headline: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    attribution: 'Illustrative Registered Nurse Feedback',
    name: 'Jennifer Morales',
    age: 38,
    role: 'Registered Nurse, Medical-Surgical Unit',
    location: 'San Antonio, Texas, United States',
    headline: 'The clinical assessments are much easier to review visually.',
    quote:
      'Having cardiovascular, respiratory, neurological, and patient monitoring references organized together makes reviewing clinical assessment information much more convenient.',
  },
  {
    attribution: 'Illustrative Clinical Nurse Feedback',
    name: 'Emily Carter',
    age: 31,
    role: 'Clinical Nurse, IV & Infusion Team',
    location: 'Manchester, United Kingdom',
    headline: 'The IV therapy references are incredibly practical.',
    quote:
      'The anatomical diagrams, catheter comparisons, infusion equipment guides, and complication references make it easier to review important vascular access concepts.',
  },
  {
    attribution: 'Illustrative Hospital Nurse Feedback',
    name: 'Sophie Tremblay',
    age: 45,
    role: 'Hospital Nurse, Surgical Ward',
    location: 'Ottawa, Ontario, Canada',
    headline: 'A much more organized approach to nursing procedures.',
    quote:
      'Instead of switching between different references, I can review wound care, medication safety, patient assessment, and bedside procedures in clearly organized modules.',
  },
  {
    attribution: 'Illustrative Nursing Professional Feedback',
    name: 'Karen Mitchell',
    age: 52,
    role: 'Charge Nurse, Acute Care',
    location: 'Brisbane, Queensland, Australia',
    headline: 'The documentation templates add real practical value.',
    quote:
      'The shift handover forms, patient assessment checklists, monitoring sheets, and safety tools provide a useful structure for organizing clinical information.',
  },
  {
    attribution: 'Illustrative Advanced Nursing Student Feedback',
    name: 'Daniel Brooks',
    age: 24,
    role: 'Final-Year BSN Nursing Student',
    location: 'Columbus, Ohio, United States',
    headline: 'A visual nursing resource worth keeping available.',
    quote:
      'The clinical illustrations, equipment comparisons, assessment references, and emergency recognition guides make this a useful companion for reviewing nursing skills.',
  },
]
